import React, { Component } from 'react';
import './WindowedApp.css';
import WindowedMenu from './WindowedMenu';
import WindowManager from './WindowManager';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';

class WindowedApp extends Component {
  render() {
	return (
	  <div className="WindowedApp">

		<WindowedMenu />

		<WindowManager />

	  </div>
	);
  }
}

export default DragDropContext(HTML5Backend)(WindowedApp);


// WEBPACK FOOTER //
// ./src/components/windowed/WindowedApp.js